import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {api} from "../../api/api";
import {CountriesState, LATAM_COUNTRY_NAMES} from "./types";

const initialState: CountriesState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchCountriesPerUserDataAsync = createAsyncThunk(
  "countriesPerUser/fetchCountriesPerUserData",
  async (year: string) => {
    const result = await api.getCountriesPerUser() || [];
    return result.filter((country) => {
      if (year === '2021') {
        return country.country_name !== LATAM_COUNTRY_NAMES.PERU &&
          country.country_name !== LATAM_COUNTRY_NAMES.ECUADOR &&
          country.country_name !== LATAM_COUNTRY_NAMES.PARAGUAY &&
          country.country_name !== LATAM_COUNTRY_NAMES.BOLIVIA
      } else {
          return !!country.country_name
      }
    });
  }
);

const countriesPerUserSlice = createSlice({
  name: "countriesPerUser",
  initialState,
  reducers: {
    clearCountriesPerUser: (state) => {
      state.data = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountriesPerUserDataAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCountriesPerUserDataAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCountriesPerUserDataAsync.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message ?? "Failed to fetch countries data per user";
      });
  },
});

export const {clearCountriesPerUser} = countriesPerUserSlice.actions;
export default countriesPerUserSlice.reducer;
